// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2cWZw","colMin":"styles_colMin__1t6m2","colCheckbox":"styles_colCheckbox__2nW-O"};